import { render, staticRenderFns } from "./ErrorOverview.vue?vue&type=template&id=670fab59&"
import script from "./ErrorOverview.controller.js?vue&type=script&lang=js&"
export * from "./ErrorOverview.controller.js?vue&type=script&lang=js&"
import style0 from "./ErrorOverview.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports